<template>
  <div class="sf-el marketing-opt-in">
    <div class="marketing-opt-in__wrapper">
      <label class="marketing-opt-in__label">
        <input
          type="checkbox"
          :checked="value"
          @change="handleChange"
          class="marketing-opt-in__checkbox"
        />
        <span class="marketing-opt-in__checkmark"></span>
        <span class="marketing-opt-in__text">
          {{ label || $t('form.marketing.opt_in_label') }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
  import { ref, watch } from 'vue';

  export default {
    name: 'MarketingOptInElement',

    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['update:modelValue'],

    setup(props, { emit }) {
      const value = ref(props.modelValue || false);
      watch(
        () => props.modelValue,
        (newValue) => {
          value.value = newValue || false;
        }
      );

      const handleChange = (event) => {
        value.value = event.target.checked;
        emit('update:modelValue', value.value);
      };

      return {
        value,
        handleChange,
      };
    },
  };
</script>

<style scoped lang="scss">
  .marketing-opt-in {
    &__wrapper {
      display: flex;
      align-items: flex-start;
    }

    &__label {
      display: flex;
      align-items: flex-start;
      gap: 0.75rem;
      cursor: pointer;
      font-size: 0.875rem;
      line-height: 1.5;
      /* Plain fallback first so older webviews keep a readable colour. */
      color: #475569;
      color: var(--cs-text-body, #475569);
    }

    &__checkbox {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }

    &__checkmark {
      flex-shrink: 0;
      width: 1.25rem;
      height: 1.25rem;
      border: 2px solid var(--cs-input-default-border, #cbd5e1);
      border-radius: 4px;
      background: var(--cs-input-default-background, #fff);
      transition: all 0.15s ease;
      position: relative;
      margin-top: 0.125rem;

      &::after {
        content: '';
        position: absolute;
        display: none;
        left: 5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }

    &__checkbox:checked + &__checkmark {
      background: var(--cs-brand-primary, #3b82f6);
      border-color: var(--cs-brand-primary, #3b82f6);

      &::after {
        display: block;
      }
    }

    &__checkbox:focus + &__checkmark {
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
    }

    &__label:hover &__checkmark {
      border-color: var(--cs-brand-primary, #3b82f6);
    }

    &__text {
      flex: 1;
    }
  }
</style>
